'use client'

import {PaginationProps} from 'antd'
import {observer} from 'mobx-react'
import {usePathname, useSearchParams} from 'next/navigation'

import {useRouter} from 'nextjs-toploader/app'
import qs from 'qs'
import {useEffect, useState} from 'react'

import {useStore} from '@/src/shared/hooks/useStore'
import {Pagination} from '@/src/shared/ui/pagination'

import * as UI from './pagination.styled'
import {VideoContent} from './screen.page'

export const VideoPagination = observer((props: PaginationProps) => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const {pageData} = useStore<VideoContent>()
  const total = pageData!.content.video_reviews.total

  const [limit] = useState(pageData!.content.video_reviews.limit)

  const [page, setPage] = useState(1)

  useEffect(() => {
    setPage(pageData!.content.video_reviews.page)
  }, [pageData!.content.video_reviews.page])

  const onChangePage = (page: number) => {
    const currentSearchParams = qs.parse(searchParams.toString()) as Record<any, any>
    const queryParams = {...currentSearchParams}

    queryParams.page = page

    const queryParamsText = qs.stringify(queryParams)

    setPage(page)

    if (queryParamsText === qs.stringify(currentSearchParams)) return
    router.push(`${pathname}${queryParamsText && `?${queryParamsText}`}`)
  }

  return (
    <UI.Pagination as={Pagination} {...props} current={page} total={total} pageSize={limit} onChange={onChangePage} />
  )
})
